import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort',
  pure: true
})
export class SortPipe implements PipeTransform {

  transform(array: any[], field?: string, asc = true): any {
    if (!array?.length) return array;
    return array.sort((a, b) => {
      var x = field ? eval(`a.${field}`) : a,
        y = field ? eval(`b.${field}`) : b;
      if (x == y) return 0;
      if (x == null) return 1;
      if (y == null) return -1;
      if (typeof x == 'string') x = x.toLowerCase();
      if (typeof y == 'string') y = y.toLowerCase();
      return x < y ? asc ? -1 : 1 : asc ? 1 : -1;
    });
  }

}
